$(function () {
    var cart = new Drawer($('.js-ajax-cart-drawer-content'), $('.js-ajax-checkout-button'), $('.js-ajax-remove-from-cart'))
    $('.add-to-cart-form').submit(function (e) {
        e.preventDefault();
        const formID = $(this).attr('id');
        cart.addProductToCart(formID);
    })
    $('.drawer__overlay').click(function (e) {
        cart.closeCartDrawer()
    })

    $('.close_button').click(function (e) {
        e.preventDefault();
        cart.closeCartDrawer()
    })

    $('.cart-icon').click(function (e) {
        e.preventDefault();
        cart.openCartDrawer();
    })
})

//class for Drawer
var Drawer = function (cartDrawerContent, checkoutButton, removeFromCartNoDot) {
    this.cartDrawerContent = cartDrawerContent;
    this.checkoutButton = checkoutButton;
    this.removeFromCartNoDot = removeFromCartNoDot;
    this.fetchCart();
};

//empty cart UI
Drawer.prototype.emptyMessage = function () {
    this.clearCartDrawer();
    $('.empty-cart').addClass('active');
    $('.drawer-title').addClass('hide');
}

Drawer.prototype.clearCartDrawer = function () {
    this.cartDrawerContent.html('');
}

//render items in UI
Drawer.prototype.renderCart = function (cart) {
    var self = this;
    this.clearCartDrawer();
    cart.items.forEach(function (item, index) {
        let color = item.variant_title;
        self.templateCart(item, index, color);
    });
    const removeFromCart = $('.ajax-cart-item__remove ');
    removeFromCart.click(function (e) {
        e.preventDefault();
        const line = $(this).parent().parent().attr('data-line');
        self.changeItem(line);
    })
    $('.quantity-minus').click(function (e) {
        e.preventDefault();
        const productID = $(this).parent().attr('data-cart-item-product-id');
        self.quantityMinus($(`#Quantity-${productID}`), productID);
    })
    $('.quantity-plus').click(function (e) {
        e.preventDefault();
        const productID = $(this).parent().attr('data-cart-item-product-id');
        self.quantityPlus($(`#Quantity-${productID}`), productID);
    })
}


Drawer.prototype.templateCart = function (item, index, color) {
    color = this.switchColor(color);
    let swatchColor = "";
    let productImage = '<div class="ajax-cart-item"><img class="ajax-cart-item__image lazyload" src="' + item.image + '" ></div>';
    let productPrice = '<div class="ajax-cart-price"><p>' + Shopify.formatMoney(item.line_price) + '</p></div>';
    let productRemove = '<div class="ajax-cart-item"><button class="ajax-cart-item__remove js-ajax-remove-from-cart"></button></div>';
    if (color != "none") {
        swatchColor = '<div class="ajax-cart-color"><span>Your variant:</span><div class="swatch-color" style="background-color:' + color + '"></div></div>';
    }
    let productTitle = '<div class="ajax-cart-item"><div class="ajax-cart-item__title">' + item.title + '</div>' + swatchColor + '</div>';
    let counter = '<div class="ajax-cart-quantity"><div class="quantity-block" data-cart-item-product-id="' + item.id + '"><button class="quantity-minus quantity-button" id="Minus-' + item.id + '"> - </button><input class="quantity-num" type="number" id="Quantity-' + item.id + '" name="quantity" value="' + item.quantity + '" min="1"><button class="quantity-plus quantity-button" id="Plus-' + item.id + '">+</button></div></div>'
    let concatProductInfo = '<div class="ajax-cart-item__container" data-line="' + Number(index + 1) + '">' + productImage + '' + productTitle + '' + productRemove + '<div class="counter-content">' + counter + '' + productPrice + '</div></div>';
    this.cartDrawerContent.append(concatProductInfo);
}

Drawer.prototype.switchColor = function (color) {
    switch (color) {
        case 'Black':
            color = '#000';
            break;
        case 'Sandstone':
            color = '#F0E4D2';
            break;
        case 'White':
            color = '#fff';
            break;
        case 'Pink':
            color = '#FFC0CB';
            break;
        case 'Silver':
            color = '#C0C0C0';
            break;
        case 'Magenta':
            color = '#FF00FF';
            break;
        default:
            color = 'none'
            break;
    }
    return color;
}
//drawer UX
Drawer.prototype.quantityMinus = function ($quantityNum, productID) {
    var self = this
    if ($quantityNum.val() > 1) {
        $quantityNum.val(+$quantityNum.val() - 1);
        self.changeItemCount($quantityNum.val(), productID);
    }
}

Drawer.prototype.openCartDrawer = function () {
    $('.drawer').addClass('active');
    $('.drawer__right').addClass('active');
}


Drawer.prototype.closeCartDrawer = function () {
    $('.drawer').removeClass('active');
    $('.drawer__right').removeClass('active');
}

Drawer.prototype.quantityPlus = function ($quantityNum, productID) {
    $quantityNum.val(+$quantityNum.val() + 1);
    this.changeItemCount($quantityNum.val(), productID);
}

Drawer.prototype.updatePrice = function (cart) {
    $('.total').html(Shopify.formatMoney(cart.total_price));
}

Drawer.prototype.updateCount = function (cart) {
    $('.cartCount').html(cart.item_count);
}

//get cart items
Drawer.prototype.fetchCart = function () {
    var self = this;
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
            if (cart.item_count === 0) {
                self.checkoutButton.addClass('is-hidden');
                $('.pricing').removeClass('active');
                $('.drawer .affirm-as-low-as').removeClass('active');
                self.emptyMessage();
            } else {
                self.renderCart(cart);
                self.updatePrice(cart);
                self.updateCount(cart);
                $('.empty-cart').removeClass('active');
                $('.drawer-title').removeClass('hide');
                $('.pricing').addClass('active');
                $('.drawer .affirm-as-low-as').addClass('active');
                self.checkoutButton.removeClass('is-hidden');
            }
        },
    });
}

//adding to cart
Drawer.prototype.addProductToCart = function (formID) {
    var self = this;
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: function (cart) {
            self.fetchCart();
            self.openCartDrawer();
        },
        error: self.addToCartFail,
    });
}


Drawer.prototype.addToCartFail = function () {
    this.cartDrawerContent.html('The product you are trying to add is out of stock.');
}

//remove
Drawer.prototype.changeItem = function (line) {
    var self = this;
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                self.fetchCart();
                self.updatePrice(cart);
                self.updateCount(cart);
            }
        },
    });
}

//plus-minus
Drawer.prototype.changeItemCount = function (quantity, variant_id) {
    var self = this;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            self.updatePrice(cart);
            self.updateCount(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    });
}